import ApiService, { errorMessage } from "helpers/ApiHelper";

const ROOT = "/api/v1/comments";

export { errorMessage };

/** How many rows one fetch asks for. The API caps any request at 500. */
export const PAGE_SIZE = 50;

/**
 * Comments for the admin queue. `status` narrows to one tab
 * (pending | approved | rejected); omit it to fetch everything.
 * The API returns newest first and pages with `limit`/`skip` — it sends no
 * total back, because the tab badges already have one from `/counts`.
 */
export const fetchComments = (status, { limit = PAGE_SIZE, skip = 0 } = {}) => {
  const query = new URLSearchParams({ limit: String(limit), skip: String(skip) });
  if (status) query.set("status", status);
  return ApiService.request(`${ROOT}?${query.toString()}`, "get");
};

/** Counts per status, used for the tab labels. */
export const fetchCommentCounts = () => ApiService.request(`${ROOT}/counts`, "get");

export const setCommentStatus = (id, status) =>
  ApiService.request(`${ROOT}/${id}/status`, "patch", { status });

export const deleteComment = (id) => ApiService.request(`${ROOT}/${id}`, "delete");
